export const Tabs = [
  //=========
  //is_mentor
  {
    id: 0,
    title: 'Реестр заявок',
    roles: ['mentor'],
    description: 'Все заявки в общем доступе, кроме заявок, предложенных администратором вам напрямую.<br> Для просмотра полной информации по заявке - кликните на строку в таблице один раз.'
  },
  {
    id: 1,
    title: 'Заявки на рассмотрении',
    roles: ['mentor'],
    description: 'Заявки, которые администратор предложил вам напрямую.<br> Для просмотра полной информации по заявке - кликните на строку в таблице один раз.'
  },
  {
    id: 2,
    title: 'Заявки в работе',
    roles: ['mentor'],
    description: 'Заявки, которые вы взяли в работу - нажали "назначить мне".<br> Завершайте работу с заявкой, если вы далее не планируете общаться с заявителем.<br> Для просмотра полной информации по заявке - кликните на строку в таблице один раз'
  },
  // {
  //   id: 2,
  //   title: 'Никто не назначен',
  //   roles: ['mentor']
  // },
  // {
  //   id: 3,
  //   title: 'Заявки на которые подписались другие менторы',
  //   roles: ['mentor']
  // },
  {
    id: 4,
    title: 'Архив',
    roles: ['mentor']
  },
  //===============
  //is_specialist
  {
    id: 5,
    title: 'Не подтвержденные заявки',
    roles: ['specialist']
  },
  {
    id: 6,
    title: 'В работе',
    roles: ['specialist']
  },
  {
    id: 7,
    title: 'Архив',
    roles: ['specialist']
  }
  /* {
    id: 1,
    title: 'Неназначенные заявки',
    count: 'danger',
    countBy: 'mentor_email',
    countCond: false,
    roles: ['master']
  },
  {
    id: 2,
    title: 'Распределенные заявки',
    count: 'success',
    countBy: 'mentor_email',
    countCond: true,
    roles: ['master']
  },
  {
    id: 3,
    title: 'Менторы',
    roles: ['master']
  },
  {
    id: 4,
    title: 'Неподтвержденные заявки',
    count: 'danger',
    countBy: 'mentor_confirmed',
    countCond: false,
    roles: ['mentor']
  },
  {
    id: 5,
    title: 'В работе',
    count: 'success',
    countBy: 'mentor_confirmed',
    countCond: true,
    roles: ['mentor']
  }, */
];
